export default __webpack_public_path__ + "static/media/r1.b2dccd45.jpg";